// ---------- import React Packs
import React from 'react';
import { Platform, Text, View } from 'react-native';
import { importRender } from './importRender'; // native map
import { useData, useRoutes } from '../../..';
import { WebMap } from './WebMap';
import { MapRentActive } from './MapRentActive';
import { pathSel, setData } from '../../project';
import { getStationInfo } from './apiCalls/getStationInfo';
import { getDBLocationData } from './apiCalls/getDBLocationData';

type Tprops = {
  pass: {
    keyPlaces: string;
    pathInitMap: string[];
    arrPins: string[];
    arrFuncs: any[];
  };
  args?: any;
};

export const MapPlaces = (props: Tprops) => {
  const { arrPins } = props.pass;
  const strPathPins = arrPins.join();
  const dataPins = useData(ct => pathSel(ct, strPathPins)) ?? [];
  const hasPins = dataPins.length > 0;
  const [sttLoad, setLoad] = React.useState(false);

  const condWeb = Platform.OS === 'web';
  // const currRoute = useRoutes(ct => ct.currRoute);
  // const isRentScreen = currRoute === 'b5timer';
  // console.log({ currRoute });

  type Trender1 = null | React.JSX.Element;
  const [SttComp, SetComp] = React.useState<Trender1>(null);

  // const condCompWeb = isRentScreen ? (
  //   <MapRentActive pass={props.pass} args={props.args} />
  // ) : (
  //   <WebMap pass={props.pass} args={props.args} />
  // );

  // ---------------------------
  // Função para atualizar pins via API
  // ---------------------------
  React.useEffect(() => {
    console.log('LOG 1', { strPathPins });
    if (!hasPins) return;

    const fetchStationInfo = async () => {
      const updatedArrData = [];
      console.log('LOG 1', { strPathPins, dataPins });

      for (const item of dataPins) {
        console.log('LOG 2', { item });

        const apiLocationID = item?.apiLocationID ?? '1';

        if (item.locationType === 'Autônomo') {
          let numBikes = '0';
          const resNumBikes = await getStationInfo(apiLocationID, 'lock');
          if (resNumBikes) numBikes = resNumBikes.numBikes;

          updatedArrData.push({ ...item, numBikes });
        }

        if (item.locationType === 'Supervisionado') {
          const numBikes = await getDBLocationData(item?.docId);
          console.log({ numBikes });
          updatedArrData.push({ ...item, numBikes });
        }
      }

      console.log('LOG 3', { updatedArrData });

      // Verifica se os dados realmente mudaram antes de setar o estado global
      if (JSON.stringify(updatedArrData) !== JSON.stringify(dataPins)) {
        setData({ path: 'temp.updatedPins', value: updatedArrData });
      }

      console.log('ANTES DO SET LOAD');
      setLoad(true);
    };

    fetchStationInfo();

    // ---------- set WEB Component apenas se necessário
    if (condWeb && !SttComp) {
      SetComp(<WebMap pass={props.pass} args={props.args} />);
    }

    // ---------- set Native Component apenas se necessário
    if (!condWeb && !SttComp) {
      const map = require('react-native-maps');
      SetComp(importRender({ res: map, props }));
    }
    // }, [strPathPins, hasPins]); // Alterado para reduzir re-renderizações desnecessárias
  }, [hasPins]); // Alterado para reduzir re-renderizações desnecessárias

  console.log({ sttLoad, hasPins });

  const condReturn = sttLoad && hasPins;
  return <>{condReturn ? SttComp : <LoadMap />}</>;
};

const LoadMap = () => {
  return (
    <View style={{ alignItems: 'center', justifyContent: 'center', flex: 1 }}>
      <Text style={{ color: '#ccc', fontSize: 22 }}>Carregando Mapa...</Text>
    </View>
  );
};
